@for (item of (toastService.items$ | async) ?? []; track $index) {
  <div>
    <app-toast-item
      [toast]="item"
      >
    </app-toast-item>
  </div>
}
